import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="Loader--Overlay">
      <div className="Loader--Content">
        <div className="Loader--Spinner"></div>
        <p className="Loader--Text">Готовим что-то вкусненькое...</p>
      </div>
    </div>
  );
};

export default Loader;
